<template>
  <div class="relative">
    <ContextMenuWrapper placement="bottom-end" test-id="header-admin" @is-visible="(val: boolean) => (isOpen = val)">
      <button
        data-testid="header-admin-trigger"
        class="flex items-center gap-2 px-3 py-2 text-sm font-semibold rounded-md transition-colors text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800 focus-visible:ring focus-visible:ring-blue-500/50 focus:outline-none"
      >
        <Icon name="general.cog" size="base" />
        <span>Admin</span>
        <Icon name="general.chevronDown" size="xs" :class="{ 'rotate-180': isOpen }" class="transition-transform duration-200" />
      </button>
      <template #menu>
        <template v-for="(item, idx) in menuItems" :key="`admin-menu-${idx}`">
          <MenuSeparator v-if="item.isSeparator" />
          <MenuLink v-else :href="item.href || '#'">
            {{ item.title }}
          </MenuLink>
        </template>
      </template>
    </ContextMenuWrapper>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { ContextMenuWrapper, Icon, MenuLink, MenuSeparator } from '@/storybook';
import { useAdminMenu } from '@/composables/useAdminMenu';

const { menuItems } = useAdminMenu();
const isOpen = ref(false);
</script>
